import { render } from "./GroupSettingsTab.vue?vue&type=template&id=4da1609a&scoped=true"
import script from "./GroupSettingsTab.vue?vue&type=script&lang=js"
export * from "./GroupSettingsTab.vue?vue&type=script&lang=js"

import "./GroupSettingsTab.vue?vue&type=style&index=0&id=4da1609a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da1609a"]])

export default __exports__